export const config = {
    // Server: "https://localhost:7141/api",
    // Client: "http://localhost:3000",
    // HanaAccUrl:"http://localhost:48721",
    Server:"https://Haanaa.ir/api",
    Client:"https://Haanaa.ir",
    HanaAccUrl:"http://HanaAcc.ir",
    FileExplorerPageSize: 20,
    GeneralListPageSize: 50,
    ShowListId: false,
    UserTokenExpirePerMinute:50
};